import PropTypes from 'prop-types';

/**
 * TODO: once we implement React.Context in Willy
 * we hook up this component along with the context
 * and remove the `event` required prop
 */
export default function ChartedEvent({ event, children }) {
    if (!event?.isSeated()) {
        return null;
    }

    return children;
}

ChartedEvent.defaultProps = {
    event: null
};

ChartedEvent.propTypes = {
    event: PropTypes.object,
    children: PropTypes.node
};
